import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable()
export class FirmwareService {

    private host: any = {};

    constructor(private client: HttpClient) {
        this.host['v1-firmware'] = environment.host('v1-firmware');
        this.host['v2-firmwares'] = environment.host('v2-firmwares');
        this.host['v2-myscale'] = environment.host('v2-myscale');
    }

    getProducts(): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/products`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getProducts.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getProducts.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastProductFirmwaresForTestUsers(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/last/${product}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getLastProductFirmwaresForTestUsers.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getLastProductFirmwaresForTestUsers.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastProductFirmwaresForBetaUsers(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/last/${product}`, {
            headers: { 'X-MyKronoz-Authorization': 'email=firmware.beta@mykronoz.com' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getLastProductFirmwaresForBetaUsers.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getLastProductFirmwaresForBetaUsers.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getLastProductFirmwaresForEndUsers(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/last/${product}`, {
            headers: { 'X-MyKronoz-Authorization': 'email=firmware@mykronoz.com' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getLastProductFirmwaresForEndUsers.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getLastProductFirmwaresForEndUsers.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getAllFirmwares(product?: string): Observable<any> {
        const params: any = {};
        if (product) {
            params.product = product;
        }
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/all`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            params: params
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getAllFirmwares.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getAllFirmwares.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    checkToken(): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/check-token`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.checkToken.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.checkToken.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    validateFirmware(firmwareId: number): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/validate/${firmwareId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.validateFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.validateFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    publishFirmware(firmwareId: number): Observable<any> {
        return this.client.request('GET', `${this.host['v1-firmware']}/v1/firmware/publish/${firmwareId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.publishFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.publishFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteFirmware(firmwareId: number): Observable<any> {
        return this.client.request('DELETE', `${this.host['v1-firmware']}/v1/firmware/${firmwareId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.deleteFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.deleteFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    uploadFirmware(file: File): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        return this.client.request('POST', `${this.host['v1-firmware']}/v1/firmware/upload`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.uploadFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.uploadFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    postFirmwareMetadata(firmwareId: number, productId: number, name: string, version: number, minVersion: number, versiontTxt: string, md5: string, force: boolean): Observable<any> {
        return this.client.request('POST', `${this.host['v1-firmware']}/v1/firmware/metadata/${firmwareId}`, {
            headers: { 'X-MyKronoz-Authorization': 'admin' },
            observe: 'response',
            body: {
                productId: productId,
                name: name,
                version: version,
                minVersion: minVersion,
                versionTxt: versiontTxt,
                md5: md5,
                force: force,
                description: '',
                translations: [/*{ locale: 'string', description: 'string' }*/]
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.postFirmwareMetadata.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.postFirmwareMetadata.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getProductsV2(): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/products`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getProductsV2.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getProductsV2.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresProductClients(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/${product}/clients`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getV2FirmwaresProductClients.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getV2FirmwaresProductClients.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresProductItems(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/${product}/items`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getV2FirmwaresProductItems.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getV2FirmwaresProductItems.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresProductVersionsForTestUsers(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/${product}/versions/last`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getV2FirmwaresProductVersionsForTestUsers.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getV2FirmwaresProductVersionsForTestUsers.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresProductVersionsForBetaUsers(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/${product}/versions/last`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;email=firmware.beta@mykronoz.com' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getV2FirmwaresProductVersionsForBetaUsers.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getV2FirmwaresProductVersionsForBetaUsers.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresProductVersionsForEndUsers(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/${product}/versions/last`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;email=firmware@mykronoz.com' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getV2FirmwaresProductVersionsForEndUsers.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getV2FirmwaresProductVersionsForEndUsers.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2FirmwaresProductVersions(product: string): Observable<any> {
        return this.client.request('GET', `${this.host['v2-firmwares']}/v2/firmwares/${product}/versions`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getAllFirmwares.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getAllFirmwares.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    uploadV2Firmware(product: string, item: string, version: string, minVersion: string, file: File): Observable<any> {
        let data = {
            product: product,
            item: item,
            version: version,
            requirements: {
                clients: [],
                items: minVersion ? [{ item: item, operator: 'GE', version: minVersion }] : []
            }
        };
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
        return this.client.request('POST', `${this.host['v2-firmwares']}/v2/firmwares/versions`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.uploadV2Firmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.uploadV2Firmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    toValidateV2Firmware(versionId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-firmwares']}/v2/firmwares/versions/${versionId}/status`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                status: 'TO_VALIDATE'
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.toValidateV2Firmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.toValidateV2Firmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    validateV2Firmware(versionId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-firmwares']}/v2/firmwares/versions/${versionId}/status`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                status: 'VALIDATED'
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.validateV2Firmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.validateV2Firmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    publishV2Firmware(versionId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-firmwares']}/v2/firmwares/versions/${versionId}/status`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                status: 'PUBLISHED'
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.publishV2Firmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.publishV2Firmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteV2Firmware(versionId: string): Observable<any> {
        return this.client.request('DELETE', `${this.host['v2-firmwares']}/v2/firmwares/versions/${versionId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.deleteV2Firmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.deleteV2Firmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateV2FirmwareVersion(versionId: string, version: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-firmwares']}/v2/firmwares/versions/${versionId}/version`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                version: version
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.updateV2FirmwareVersion.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.updateV2FirmwareVersion.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateV2FirmwareRequirements(versionId: string, item: string, minVersion: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-firmwares']}/v2/firmwares/versions/${versionId}/requirements`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                requirements: {
                    clients: [],
                    items: minVersion ? [{ item: item, operator: 'GE', version: minVersion }] : []
                }
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.updateV2FirmwareRequirements.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.updateV2FirmwareRequirements.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    getV2MyScaleFirmwares(): Observable<any> {
        return this.client.request('GET', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.getV2MyScaleFirmwares.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.getV2MyScaleFirmwares.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    uploadV2MyScaleFirmware(internalModel: string, hardwareModel: string, version: number, mkzVersion: string, crc: string, file: File): Observable<any> {
        let data = {
            internalModel: internalModel,
            hardwareModel: hardwareModel,
            version: version,
            mkzVersion: mkzVersion,
            crc: crc
        };
        const formData: FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
        return this.client.request('POST', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: formData
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.uploadV2MyScaleFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.uploadV2MyScaleFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    toValidateV2MyScaleFirmware(versionId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions/${versionId}/status`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                status: 'TO_VALIDATE'
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.toValidateV2MyScaleFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.toValidateV2MyScaleFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    validateV2MyScaleFirmware(versionId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions/${versionId}/status`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                status: 'VALIDATED'
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.validateV2MyScaleFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.validateV2MyScaleFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    publishV2MyScaleFirmware(versionId: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions/${versionId}/status`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                status: 'PUBLISHED'
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.publishV2MyScaleFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.publishV2MyScaleFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    updateV2MyScaleFirmwareVersion(versionId: string, version: number, mkzVersion: string): Observable<any> {
        return this.client.request('PUT', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions/${versionId}/version`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response',
            body: {
                version: version,
                mkzVersion: mkzVersion
            }
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.updateV2MyScaleFirmwareVersion.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.updateV2MyScaleFirmwareVersion.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }

    deleteV2MyScaleFirmware(versionId: string): Observable<any> {
        return this.client.request('DELETE', `${this.host['v2-myscale']}/v2/myscale/firmwares/versions/${versionId}`, {
            headers: { 'X-MyKronoz-Authorization': 'v2;admin' },
            observe: 'response'
        }).pipe(
            map((response: HttpResponse<any>) => {
                console.debug('FirmwareService.deleteV2MyScaleFirmware.map', response);
                return response.body;
            }),
            catchError((response: HttpErrorResponse) => {
                console.debug('FirmwareService.deleteV2MyScaleFirmware.catchError', response);
                if (response.error instanceof ErrorEvent) {
                } else {
                }
                return throwError(() => ({ status: response.status }));
            })
        );
    }
}
